export const AUTH_GETTERS = {
  VERIFY_HASH: 'verifyHash',
  VERIFICATION: 'verification',
};

export const AUTH_ACTIONS = {
  SET_VERIFY_HASH: 'setVerifyHash',
  SET_VERIFICATION: 'setVerification',
};

export const AUTH_MUTATIONS = {
  SET_VERIFY_HASH: 'setVerifyHash',
  SET_VERIFICATION: 'setVerification',
};

export default {
  namespaced: true,
  state: {
    verifyHash: undefined,
    verification: undefined,
  },
  getters: {
    [AUTH_GETTERS.VERIFY_HASH]: state => state.verifyHash,
    [AUTH_GETTERS.VERIFICATION]: state => state.verification,
  },
  actions: {
    [AUTH_ACTIONS.SET_VERIFY_HASH]: async ({commit}, verifyHash) => { commit(AUTH_MUTATIONS.SET_VERIFY_HASH, verifyHash) },
    [AUTH_ACTIONS.SET_VERIFICATION]: async ({commit}, verification) => { commit(AUTH_MUTATIONS.SET_VERIFICATION, verification) },
  },
  mutations: {
    [AUTH_MUTATIONS.SET_VERIFY_HASH]: (state, verifyHash) => { state.verifyHash = verifyHash },
    [AUTH_MUTATIONS.SET_VERIFICATION]: (state, verification) => { state.verification = verification },
  },
}
